// extracted by mini-css-extract-plugin
export default {"comment_box":"index_comment_box_zsbmv","title":"index_title_iQ7hW","bg_box":"index_bg_box_y7-6H","counts":"index_counts_X2D73"};